<template>
  <div class="c28-wrap">
    <section ref="print">
      <div class="mytitle">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>
              {{ this.$moment(this.startDate).format("YYYY-MM-DD") }}
            </span>
            <span v-if="$parent.endTimeShow">
              至{{ this.$moment(this.endDate).format("YYYY-MM-DD") }}
            </span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
        </li>-->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <div class="c28-container">
        <div>
          <div class="PreArrivalItem">
            <div class="zhanghao">账号</div>
            <div class="xingming">姓名</div>
            <div class="fanghao">房号</div>
            <div class="fangxing">账项</div>
            <div class="shijian3">发生时间</div>
            <div class="fangjia" style="text-align:right">单价</div>
            <div class="jianshu">数量</div>
            <div class="fangjia" style="text-align:right">金额</div>
            <div class="fangxing">操作员</div>
            <div style="text-align:left;padding-left:10px;flex:1">
              单号/备注
            </div>
          </div>
          <div
            v-for="(item2, index) in preArrivalList"
            :key="index"
            style="border-bottom:1px dotted black"
          >
            <div class="PreArrivalItem">
              <div class="zhanghao">{{ item2.accNo }}</div>
              <div class="xingming">{{ item2.guestName }}</div>
              <div class="fanghao">{{ item2.roomNo }}</div>
              <div
                class="fangxing"
                v-if="item2.goodName != null && item2.goodName != ''"
              >
                {{ item2.goodName }}
              </div>
              <div class="fangxing" v-else>{{ item2.chnName }}</div>
              <div class="shijian3">{{ item2.updateTime }}</div>
              <div class="fangjia" style="text-align:right">
                {{ $parent.curreny(item2.price) }}
              </div>
              <div class="jianshu">{{ item2.num }}</div>
              <div class="fangjia" style="text-align:right">
                {{ $parent.curreny(item2.amount) }}
              </div>
              <div class="fangxing">{{ item2.operator }}</div>
              <div style="text-align:left;padding-left:10px;flex:1">
                {{ item2.remark }}
              </div>
            </div>
            <div class="c28-foot">
              <div>小计</div>
              <div></div>
              <div style="text-align:right">
                {{ $parent.curreny(item2.amount) }}
              </div>
            </div>
          </div>
          <div class="c28-foot">
            <div>合计</div>
            <div></div>
            <div style="text-align:right">{{ $parent.curreny(total) }}</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      preArrivalList: [],
      allPrice: 0,
      total: 0,
      // 记录
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  created() {
    this.$parent.bbmc = "C28.区间消费房吧报表";
    this.$parent.closeshow();
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.czy = this.$store.state.userInfo.cusercode;
    // this.$parent.showCzy = true;
    this.$parent.startTimeShow = true;
    this.$parent.endTimeShow = true;
    this.$parent.showZx2 = true;
    this.$parent.showyjz = true;
    this.$parent.showBc = true;
    this.$parent.showFh = true;
    this.$parent.chaxunvib = true;

    this.getPreArrivalList();
  },
  methods: {
    dodayin() {
      this.$print(this.$refs.print);
    },
    doserach() {
      if (new Date(this.$parent.startDate) <= new Date(this.$parent.endDate)) {
        this.getPreArrivalList();
      } else {
        this.$mymessage({
          content: "截止日期必须大于开始日期",
          type: "error",
          time: 3000,
          hasClose: true,
        });
      }
    },

    getPreArrivalList() {
      var postparm = {
        startDate: this.$parent.startDate,
        endDate: this.$parent.endDate,
        // txnItem: this.$parent.zx2,
        // type: this.$parent.yjz,
        roomId: this.$parent.roomno,
        shift: this.$parent.banci,
      };
      if (this.$parent.zx2 == null) {
        let arr = [];
        this.$parent.tFinanceAccountsItemJ2.forEach((item) => {
          arr.push(item.ccode);
        });

        postparm.txnItem = arr;
      } else {
        let arr = [];
        arr.push(this.$parent.zx2);
        postparm.txnItem = arr;
      }
      if (this.$parent.banci > 0) {
        postparm.shift = this.$parent.banci;
      }
      if (this.$parent.yjz == 1) {
        postparm.type = this.$parent.yjz;
      }
      // return;
      let loadingInstance = this.$loading({ text: "正在查询..." });
      postRequest("/reportFrontCash/selectPosMenuConsumeItem", postparm).then(
        (res) => {
          this.$parent.datacount = res.data.length;
          this.preArrivalList = [];
          this.allPrice = 0;

          this.$nextTick(() => {
            loadingInstance.close();
          }); //不回调
          if (res.status == 200) {
            this.preArrivalList = res.data;
            res.data.forEach((item) => {
              if (item.goodName == null) {
                item.goodName = item.chnName;
              }
            });
            this.$store.state.preArrivalList = res.data;
            this.$store.state.preArrivalName = "C28.区间消费房吧报表";
            let alltotal = 0;
            this.preArrivalList.forEach((item) => {
              alltotal += item.amount;
            });
            this.total = alltotal;
            this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
            this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
            this.startDate= this.$parent.startDate;
            this.endDate= this.$parent.endDate;
          } else {
            this.$mymessage({
              content: res.code,
              type: "error",
              time: 3000,
              hasClose: true,
            });
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.fanghao {
  width: 60px;
}
.c28-wrap {
  width: 100%;
  padding: 20px;
}
.c28-head > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.c28-head > div div {
  flex: 1;
  line-height: 22px;
  font-size: 14px;
}
.c28-head > div div:nth-child(2) {
  text-align: center;
}
.c28-head > div div:nth-child(3) {
  text-align: right;
}
.c28-container {
  margin-top: 10px;
  /* border-top: 1px solid black; */
  padding-top: 2px;
}
.c28-container > div {
  font-size: 14px;
  margin-bottom: 3px;
  /* background: cornflowerblue; */
}

.c28-container > div:last-child {
  border-bottom: 1px solid black;
  padding-bottom: 3px;
}
.c28-line1 {
  display: flex;
  /* border-bottom: 1px dashed; */
}
.c28-line2 {
  display: flex;
  width: 100%;
}
.c28-line1 > div,
.c28-line2 > div {
  /* flex: 1; */
  width: 120px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}
.c28-line3 {
  display: flex;
  justify-content: center;
}
.c28-line3 > div {
  margin-right: 3%;
  /* font-weight: 600; */
}
.c28-line3 > div:nth-child(1),
.c28-line3 > div:nth-child(3) {
  font-weight: 600;
}
.title {
  display: flex;
  line-height: 24px;
  border-bottom: 1px solid black;
  /* border-top: 1px solid black; */
  font-size: 14px;
  font-weight: 400;
  padding: 3px 0;
}
.title > div {
  flex: 1;
  text-align: center;
  border-bottom: 1px solid black;
  border-top: 1px solid black;
}
.c28-foot {
  display: flex;
  font-size: 14px;
  margin-top: 12px;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
}
.c28-foot > div {
  /* flex: 1; */
  font-weight: 600;
  line-height: 24px;
  margin-right: 30px;
}
.c28-foot > div:nth-child(2) {
  width: 60px;
}
.c28-line2 {
  border-top: 1px dotted black;
}
.mytitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px !important;
  line-height: 24px;
  margin-bottom: 1em;
}
</style>
